import {BigCalendarUser} from 'platform/big-calendar';

export const getNonHiddenSelectedUserIds = (selectedUsers: BigCalendarUser[]) =>
  selectedUsers.filter((user) => user.id && !user.isHidden).map((user) => user.id);
